import React from 'react';
import './CollectionPage.css';
import '@shopify/polaris/dist/styles.css';
import Collection from '../components/Collection';
import AuthenticatedPage from '../components/AuthenticatedPage';

interface CollectionPageProps {
  id: string;
  match: any;
}

function CollectionPage(props: CollectionPageProps) {
  return (
    <AuthenticatedPage>
      {shopOrigin => <Collection shopOrigin={shopOrigin} type="existing" id={props.match.params.collectionId} />}
    </AuthenticatedPage>
  );
}

export default CollectionPage;
